export default "__VITE_ASSET__DS3fufG4__"